var colsimage = {
    init: function() {

        var self = this;

		self.scrollCheck();
        self.lazySvgCols();
    },
    lazySvgCols: function () {
        var images = jQuery("image");
        images.each(function(){
            var image = jQuery( this );
            
            image.attr('href', image.attr('data-href'));
            image.on("load", function () {
                // console.log('loaded');
                image.removeAttr('data-href');
            });
        });
    },
    scrollCheck: function () {
        if( ! jQuery( '.js-cols-images' ).length ) {
            //return;
        }
        
        var scrolled =  jQuery(window).scrollTop();
        var windowHeight = jQuery(window).height();

        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();


        jQuery( ".js-cols-images" ).each(function() {
            var fromTop = jQuery( this ).offset().top;
            var height = jQuery( this ).outerHeight();

            var fullWidth  = jQuery( this ).outerWidth();

            var top_of_element = $( this ).offset().top;
            var bottom_of_element = $( this ).offset().top + $( this ).outerHeight();

            jQuery( this ).find( 'image' ).css( 'width', fullWidth + 'px' );      

            if ( ( bottom_of_screen > top_of_element ) && ( top_of_screen < bottom_of_element ) ){

                var nthCol = 0;
                
                jQuery( this ).find("rect").each(function() {
                    
                    var baseTop = jQuery( this).data("top");
                    var baseHeight = jQuery( this).data("height");
                    var realHeight = this.getBoundingClientRect().height;
                    var baseWidth = jQuery( this).data("width");
                    var baseDirection = jQuery( this).data("direction");

                    var colWidth = fullWidth * ( baseWidth / 100 );

                    var fullPath = "";
                    var actualPath = "";

                    jQuery(this).css( 'width', colWidth + 'px' );

                    if( baseDirection == "top" ) {
                        fullPath = 100 - baseHeight - baseTop;
                    }
                    else {
                        fullPath = baseTop;
                    }

                    //console.log(bottom_of_screen - top_of_element);
                    //
                    //console.log( windowHeight + height);
                    
                    actualPath =  ( (bottom_of_screen - top_of_element) / ( windowHeight + height) );

                    var fromLeft = baseWidth * nthCol;
                    

                    if( baseDirection == "top" ) {
                        fromTop = ( baseHeight + baseTop ) + ( actualPath * fullPath );
                        jQuery(this).css("transform",  "translateX(" + fromLeft + "%) translateY( calc(" + fromTop + "% - " + realHeight + "px ) )");
                    }
                    else {
                        fromTop =  fullPath - (fullPath * actualPath ); 

                        if( nthCol == 1 ) {
                            // console.log(fullPath);
                        }

                        jQuery(this).css("transform",  "translateX(" + fromLeft + "%) translateY( " + fromTop + "% )");
                    }

                    nthCol = nthCol+1;
                });
            }
        });
	}
}

export {
    colsimage
};	